const mediaItems = [
  {
    title: '热血日漫推荐：不可错过的十部经典',
    desc: '从《海贼王》到《咒术回战》，带你回顾那些燃爆青春的热血漫画作品。',
    img: 'https://readdy.ai/api/search-image?query=Dynamic%20action%20anime%20scene%20with%20epic%20battle%20composition%2C%20warm%20orange%20and%20red%20energy%20effects%2C%20Japanese%20manga%20style%20illustration%2C%20dramatic%20lighting%2C%20clean%20flat%20color%20style%2C%20minimal%20white%20background&width=800&height=450&seq=media-manga-01&orientation=landscape',
    icon: 'ri-play-circle-line',
    tag: '日漫',
  },
  {
    title: '韩漫入坑指南：从零开始的韩漫之旅',
    desc: '了解韩漫独特的条漫格式和上色风格，发现韩漫世界的无限魅力。',
    img: 'https://readdy.ai/api/search-image?query=Elegant%20Korean%20webtoon%20style%20illustration%20with%20beautiful%20character%20portrait%2C%20soft%20pastel%20color%20palette%2C%20romantic%20atmosphere%2C%20clean%20digital%20art%20style%2C%20minimal%20neutral%20background&width=800&height=450&seq=media-manga-02&orientation=landscape',
    icon: 'ri-play-circle-line',
    tag: '韩漫',
  },
  {
    title: '国漫崛起：国产漫画的黄金时代',
    desc: '从《一人之下》到《镖人》，国漫正以独特的中式美学征服全球读者。',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20style%20illustration%20with%20traditional%20ink%20painting%20aesthetic%2C%20martial%20arts%20theme%2C%20elegant%20flowing%20lines%2C%20warm%20earth%20tones%20with%20golden%20accents%2C%20clean%20art%20composition%2C%20minimal%20cream%20background&width=800&height=450&seq=media-manga-03&orientation=landscape',
    icon: 'ri-play-circle-line',
    tag: '国漫',
  },
  {
    title: '漫画阅读技巧：如何高效追更不踩坑',
    desc: '教你使用酷漫屋的下拉式滚动阅读功能，以及各种实用的漫画追更小技巧。',
    img: 'https://readdy.ai/api/search-image?query=Cozy%20reading%20scene%20with%20digital%20tablet%20displaying%20colorful%20manga%20art%2C%20warm%20ambient%20lighting%2C%20comfortable%20setting%2C%20clean%20modern%20illustration%20style%2C%20soft%20beige%20background&width=800&height=450&seq=media-manga-04&orientation=landscape',
    icon: 'ri-play-circle-line',
    tag: '指南',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-3">
          漫画指南
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          漫画入坑不迷路，从入门到精通的实用指南
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {mediaItems.map((item) => (
            <div key={item.title} className="group bg-background-50 rounded-2xl border border-background-200/80 overflow-hidden cursor-pointer transition-transform hover:-translate-y-1">
              <div className="relative w-full aspect-video overflow-hidden bg-background-200">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-white/90 flex items-center justify-center">
                    <i className={`${item.icon} text-primary-500 text-xl`}></i>
                  </div>
                </div>
                <span className="absolute top-3 left-3 px-2 py-0.5 rounded-md bg-white/90 text-xs font-medium text-primary-600 whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-medium text-foreground-800 mb-1 line-clamp-2">{item.title}</h3>
                <p className="text-xs text-foreground-500 line-clamp-2">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}